import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Ransom Mediator · Your Partner in Resolution</p>
        <h1>Navigate Ransom Situations with Confidence</h1>
        <p className="lede">
          At Ransom Mediator, we specialize in helping businesses effectively negotiate and resolve ransom situations. Our expert legal consulting services are designed to protect your interests and guide you through challenging circumstances.
        </p>
        <div className="cta-row">
          <a href="/services" target="_self">
            Learn About Our Services
          </a>
          <a href="/contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Expert Negotiation</h2>
          <p>
            Our team of experienced legal consultants will work with you to develop effective negotiation strategies tailored to your specific situation.
          </p>
        </article>
        <article>
          <h2>Comprehensive Support</h2>
          <p>
            We provide end-to-end support, from initial assessment to resolution, ensuring you have the guidance you need every step of the way.
          </p>
        </article>
        <article>
          <h2>Proactive Risk Management</h2>
          <p>
            Our services include risk assessment and management strategies to help you minimize vulnerabilities and prepare for potential threats.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;